// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StreakSingleFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M62.348 48.765c-.028.067-.066.128-.102.192-.027.05-.05.103-.083.152a1.9 1.9 0 0 1-.251.307l-6.655 6.655a1.99 1.99 0 0 1-1.414.586 2 2 0 0 1-1.414-3.414L55.672 50H34.5a2 2 0 0 1 0-4h21.172l-3.243-3.242a2 2 0 1 1 2.828-2.828l6.655 6.655c.094.093.178.196.25.306.034.049.057.102.084.153.036.063.074.124.102.192.026.065.042.133.062.2.017.058.04.113.05.173.052.258.052.525 0 .783-.01.06-.033.114-.05.17-.02.069-.036.138-.062.203ZM18.5 38c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10Zm59 0c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default StreakSingleFilled;
